<template>
  <form class="nameform" @submit="next">
    <div class="content">
      <h1 class="mb-6 text-center big-title">
        Conferma la richiesta carta
      </h1>

      <p class="text-center">
        Inserisci il mobile token
      </p>
      <div class="mt-10">
        <VerifyCode @onUpdate="v => (code = v)" />
      </div>
      <hr class="my-10" />
      <div class="md:text-center">
        <div v-if="!smsSent">
          <p class="mb-3 f-m">Non hai ricevuto il mobile token?</p>
          <div v-if="isDesktopOrAndroid()" class="flex items-center mb-5">
            <img width="20" src="../../assets/images/idea.png" style="margin-left: -4px;">
            <p class="ml-2 f-r" style="font-size: 12px;color: #585858;">Controlla anche nello SPAM dei tuoi SMS</p>
          </div>
          <div @click="resendSms" class="mb-8 link">
            Richiedi un nuovo codice
          </div>
        </div>
        <div v-else>
          <p style="color: #57B268" class="mb-3 f-m">SMS inviato!</p>
          <div class="mb-8 text-grey">
            Controlla sul tuo dispositivo
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button
        class="btn desktop-only"
        :disabled="code.length < 6"
        @click="next"
      >
        Prosegui
      </button>
    </div>
    <NumericPad renderButton="true">
      <button class="btn" :disabled="code.length < 6" type="submit">
        Prosegui
      </button>
    </NumericPad>
  </form>
</template>

<script>
import VerifyCode from "@/components/VerifyCode";
import NumericPad from "@/components/NumericPad";
import SecurityService from "@/services/SecurityService";
import UtilityService from "@/services/UtilityService";
import RegistrationService from "@/services/RegistrationService";

export default {
  name: "MinorConfirmMobileToken",
  components: {
    VerifyCode,
    NumericPad
  },
  data() {
    return {
      phoneNumber: this.$store.state.user.phoneNumber,
      code: "",
      smsSent: false
    };
  },
  mounted() {
    this.$root.$on("openedNumericPad", this.openedNumericPad);
    //RegistrationService.sendOtp();
  },
  methods: {
    resendSms() {
      RegistrationService.sendOtp().then(
        () => {
          this.smsSent = true;
          setTimeout(() => {
            this.smsSent = false;
          }, 60000);
        },
        () => {
          UtilityService.showErrorModal(
            "Non è stato possibile inviare un nuovo SMS. Per maggiori informazioni contattaci"
          );
        }
      );
    },
    openedNumericPad() {
      UtilityService.scrollTopPage();
    },
    backToPinCode(error) {
      this.$router.push({
        name: "ConfirmAccessCode",
        params: {
          skipNewToken: true,
          errors: error
        }
      });
      this.$root.$emit("changedRoute");
    },
    isDesktopOrAndroid() {
      return UtilityService.isDesktopOrAndroid();
    },
    async next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      try {
        await SecurityService.verifyIcOtp({
          otp: this.code,
          password: this.$store.state.user.confirmAccessCode
        });

        await RegistrationService.upgradeRegistrationProgress(4);

        this.$root.$emit("submitStep");
      } catch (error) {
        //TODO: error handling
        console.log(error);
        this.loading = false;
        this.backToPinCode({
          pinCode:
            "Il codice di accesso e/o il mobile token inseriti non sono corretti. Verificali e riprova"
        });
      }
    }
  }
};
</script>
